export default "__VITE_ASSET__DmYyIHIE__"